import { FeedbackData } from '@modules/App/interfaces/feedback';
import { createAction } from '@reduxjs/toolkit';

export const sendFeedback = createAction<FeedbackData>('feedback/sendFeedback');
